import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__i2cc2i-created',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__i2cc2i-created .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__i2cc2i-features',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__i2cc2i-features .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__i2cc2i-implementation',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__i2cc2i-implementation .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__i2cc2i-steps',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__i2cc2i-steps .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__i2cc2i-solutions',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__i2cc2i-solutions .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__connect',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__connect .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);
});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/iban2card-card2iban.js